import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    title: null,
    body: null,
}

const snackSuccessSlice = createSlice({
    name: 'success',
    initialState,
    reducers: {
        setSuccessSnack: (state, action) => {
            state.title = action.payload.title
            state.body = action.payload.body
        }
    }
})

export const { setSuccessSnack } = snackSuccessSlice.actions;
export default snackSuccessSlice.reducer;